import React, { Fragment, useEffect, useState } from 'react';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';
import { useRouteMatch } from 'react-router-dom';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { Button, Card, Grid, ListItemText, Typography } from '@material-ui/core';
import { Camera, Download } from 'react-feather';
import { CommonLogic } from '@jewelutions/core-common-logic';
import DeliveryUnitSaleCatalogPreviewOrderDialog from './DeliveryUnitSaleCatalogPreviewOrderDialog';

interface IProps {
  party: GQLParty;
}

const DeliveryUnitSaleCatalogPreview: React.FC<IProps> = ({ party }: IProps) => {
  const [commonView, setCommonView] = useState(null);
  const [isOrderPreviewDialogOpen, setIsOrderPreviewDialogOpen] = useState(false);
  const [itemCustomisations, setItemCustomisations] = useState([] as string[]);
  const { deliveryUnitId } = ProducerNavigation.deliveryUnitActiveSaleCatalogPreview.paramsFromPath(
    useRouteMatch()
  );

  const { data, loading } = GQLOperationBuilder.deliveryUnit.getDesignerCatalogForDeliveryUnit({
    deliveryUnitId: deliveryUnitId
  });

  useEffect(() => {
    async function initialiseDesigner() {
        const catalog = JSON.parse(
        CommonLogic.Base64.fromBase64(GQLOperationBuilder.deliveryUnit.designerCatalogFromResponse(data))
      );

      const commonViewApi = await (globalThis as any).Jewelutions.developmentLoad(
        (globalThis as any).Jewelutions.configurationBuilder()
          .withAppRootDomElementId('designer_app')
          .withCatalog(catalog)
          .build()
      );
      setCommonView(commonViewApi);
    }
    if (data) {
      initialiseDesigner();
    }
  }, [data]);

  const downloadScreenshot = async () => {
    const view = commonView as any;
    const base64Image = await view.exportCanvasImage();

    const element = document.createElement('a');
    if (base64Image) {
      element.href = base64Image;
      element.download = `image.png`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    }
  };

  return (
    <React.Fragment>
    <Card style={{ padding: '8px', marginBottom: '8px' }}>
    <div style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
    <Button
          variant="contained"
          color="primary"
          onClick={() => {
            downloadScreenshot();
          }}
        >
          <Camera />
          <span style={{ marginLeft: '4px' }}>Download screenshot</span>
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            const view = commonView as any;
            if (view) {
              const itemCustomisation = CommonLogic.Base64.encode(
                JSON.stringify(view.getDesignerSdk().design.getCurrentState())
              );
              setItemCustomisations([itemCustomisation]);
              setIsOrderPreviewDialogOpen(true);
            }
          }}
        >
          <Download />
          <span style={{ marginLeft: '4px' }}>Preview producer order</span>
        </Button>
        </div>
        <div style={{ marginBottom: '8px', display: 'flex', width: '100%' }}>
          <div id="designer_app" style={{ width: '80%' }}></div>
        </div>
  </Card>

      {isOrderPreviewDialogOpen && (
        <DeliveryUnitSaleCatalogPreviewOrderDialog
          party={party}
          deliveryUnitId={deliveryUnitId}
          itemCustomisations={itemCustomisations}
          onClose={() => {
            setIsOrderPreviewDialogOpen(false);
          }}
        />
      )}
      </React.Fragment>
  );
};
export default DeliveryUnitSaleCatalogPreview;
